/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserRoles} from '../models/UserRoles';

export interface GetAllUserRoles$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAllUserRolesRequest = createAction<PayloadData<void>>('USER_ROLE_CONTROLLER__GET_ALL_USER_ROLES__REQUEST');
export const getAllUserRolesSuccess = createAction<PayloadData<Array<UserRoles>>>('USER_ROLE_CONTROLLER__GET_ALL_USER_ROLES__SUCCESS');
export const getAllUserRolesFailure = createAction<PayloadData<Error, void, true>>('USER_ROLE_CONTROLLER__GET_ALL_USER_ROLES__FAILURE');

export const getAllUserRolesActions = [
    getAllUserRolesRequest,
    getAllUserRolesSuccess,
    getAllUserRolesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAllUserRoles = (config?: GetAllUserRoles$Config) => {
    return {
        CALL_API: {
            types: getAllUserRolesActions,
            method: ApiMethods.GET,
            endpoint: `/users/roles`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface RemoveUserRoles$Request {
    email: string;
}

export interface RemoveUserRoles$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeUserRolesRequest = createAction<PayloadData<void, RemoveUserRoles$Request>>('USER_ROLE_CONTROLLER__REMOVE_USER_ROLES__REQUEST');
export const removeUserRolesSuccess = createAction<PayloadData<void, RemoveUserRoles$Request>>('USER_ROLE_CONTROLLER__REMOVE_USER_ROLES__SUCCESS');
export const removeUserRolesFailure = createAction<PayloadData<Error, RemoveUserRoles$Request, true>>('USER_ROLE_CONTROLLER__REMOVE_USER_ROLES__FAILURE');

export const removeUserRolesActions = [
    removeUserRolesRequest,
    removeUserRolesSuccess,
    removeUserRolesFailure
] as const;

/**
 * @param {string} meta.email
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeUserRoles = (meta: RemoveUserRoles$Request, config?: RemoveUserRoles$Config) => {
    const TRANSPORT_GET_PARAMS = {
        email: meta.email,
    };
    return {
        CALL_API: {
            types: removeUserRolesActions,
            method: ApiMethods.DELETE,
            endpoint: `/users/roles/remove`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveUserRoles$Request {
    userRoles: UserRoles;
}

export interface SaveUserRoles$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveUserRolesRequest = createAction<PayloadData<void, SaveUserRoles$Request>>('USER_ROLE_CONTROLLER__SAVE_USER_ROLES__REQUEST');
export const saveUserRolesSuccess = createAction<PayloadData<void, SaveUserRoles$Request>>('USER_ROLE_CONTROLLER__SAVE_USER_ROLES__SUCCESS');
export const saveUserRolesFailure = createAction<PayloadData<Error, SaveUserRoles$Request, true>>('USER_ROLE_CONTROLLER__SAVE_USER_ROLES__FAILURE');

export const saveUserRolesActions = [
    saveUserRolesRequest,
    saveUserRolesSuccess,
    saveUserRolesFailure
] as const;

/**
 * @param {UserRoles} meta.userRoles
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveUserRoles = (meta: SaveUserRoles$Request, config?: SaveUserRoles$Config) => {
    return {
        CALL_API: {
            types: saveUserRolesActions,
            method: ApiMethods.POST,
            endpoint: `/users/roles/save`,
            TRANSPORT_REQUEST_BODY: meta.userRoles,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

